import assemble from '@src/common/lang/assemble'

export default {
  /**
   * Avue组件库内置的国际化配置 ----START
   * 1.如下可对avue的内置国际化配置进行自定义设置,只允许修改对应的value值,key值不能修改,否则avue不能识别,当配置国际化时仍然会使用其源码内置的配置项
   * 2.具体各项对应的中文可在 ./zh.js中查看
   * 3.目前avue暂支持部分中英文,更多语言请登录官网查看语言包更新方式
   * */
  common: {
    condition: 'Condition',
    display: 'Display',
    hide: 'Hide',
  },
  tip: {
    select: 'please select',
    input: 'please input',
  },
  date: {
    start: 'Start date',
    end: 'End date',
    tip: 'to',
    year: 'year',
    month: 'month',
    hours: 'hours',
    t: 'today',
    y: 'yesterday',
    n: 'nearly 7',
    a: 'whole',
  },
  crud: {
    filter: {
      addBtn: 'Add',
      clearBtn: 'Clear',
      resetBtn: 'Reset',
      cancelBtn: 'Cancel',
      submitBtn: 'Submit',
    },
    tipStartTitle: 'Currently selected',
    tipEndTitle: 'Term',
    editTitle: 'Edit',
    addTitle: 'Add',
    viewTitle: 'View',
    filterTitle: 'Filter',
    // 表格操作栏
    menu: 'Operation',
    addBtn: 'Add',
    showBtn: 'Show',
    closeBtn: 'Close',
    filterBtn: 'Filter',
    // 刷新按钮
    refreshBtn: 'Refresh',
    // 打印按钮
    printBtn: 'Print',
    excelBtn: 'Excel',
    updateBtn: 'Save',
    cancelBtn: 'Cancel',
    columnBtn: 'Column',
    searchBtn: 'Query',
    emptyBtn: 'Reset',
    menuBtn: 'Options',
    saveBtn: 'Save',
    viewBtn: 'View',
    editBtn: 'Edit',
    delBtn: 'Delete',
  },
  /**
   * 该部分配置主要以公共基础组件为主,不包含业务基础组件
   * 涵盖范围如下
   * common-modules\src\components\common\
   * common-modules\src\components\error-page
   * common-modules\src\components\global
   * common-modules\src\views\home
   * common-modules\src\views\user
   */
  base: {
    placeholder: {
      username: 'Enter username',
      password: 'Enter password',
      account: 'Enter account',
      name: 'Enter name',
      sex: 'Select Sex',
      phone: 'Enter cellphone',
      email: 'Enter email',
      remark: 'Enter remark',
      oldPwd: 'Enter old password',
      newPwd: 'Enter new password',
      confirmPwd: 'Enter confirm password',
    },
    button: {
      backHome: 'Back to Home',
      start: 'Start',
      close: 'Close',
      set: 'Setting',
      logout: 'Logout',
      confirm: 'Confirm',
      reset: 'Reset',
      view: 'View',
      cancel: 'Cancel',
      login: 'Login',
      getSN: 'Get serial number',
      copy: 'Copy',
      upload: 'Upload',
      save: 'Save',
    },
    label: {
      sex: 'sex',
      avatar: 'avatar upload',
      personalInfo: 'Personal Info',
      editPwd: 'Edit Password',
      account: 'Account',
      name: 'Name',
      index: 'Index',
      phone: 'Phone',
      email: 'Email',
      remark: 'Remark',
      oldPwd: 'Old password',
      newPwd: 'New password',
      confirmPwd: 'Confirm password',
      alarmName: 'Alarm name',
      alarmLevel: 'Alarm level',
      alarmTime: 'Alarm time',
      // licence.vue
      mac: 'MAC',
      empty: 'empty',
      sn: 'Serial number',
      publicKey: 'Public key',
      uploadFile: 'Upload file',
    },
    title: {
      warn: 'Warning',
      notify: 'Alarm notification',
    },
    message: {
      tipsmenu: 'You do not have any permissions, please contact the administrator!',
      tips403: "Sorry, you don't have access to this page",
      tips404: 'Sorry, the page you visited does not exist.',
      tips500: 'Sorry, Internal Server Error',
      fileExceed: 'File out of limit',
      sockettime: 'Your task 【{taskName}】 will start in {time} minutes, start now ?',
      socketnow: 'Your task 【{taskName}】 has reached the scheduled start time, start now ?',
      confirmOut: 'Are you sure to logout?',
      account: 'Enter account',
      name: 'Enter name',
      less50: 'The length is between 1 and 50 characters',
      phone: 'Enter cellphone',
      phoneCheck: 'Phone number format is incorrect',
      email: 'Enter email',
      emailCheck: 'Email format is incorrect',
      emailFormat: 'Mailbox prefix is 4 to 18 characters',
      remark: 'Enter remark',
      oldPwd: 'Enter old password',
      newPwd: 'Enter new password',
      password: 'Enter password',
      less20: 'The length is between 6 and 20 characters',
      confirmPwd: 'Enter confirm password',
      sameWithAccount: 'The new password cannot be the same as the account name',
      editPwdSuccess: 'Password update successfully',
      againPwd: 'Enter your password again',
      diffPwd: 'Inconsistent input password twice',
      passwordCheck2: 'The password is in the wrong format and must contain two or more of letters, numbers, and special characters',
      editSuccess: 'Update successfully',
      onlyLicence: 'Only support the license file, and no more than 500kb',
      noage: 'Age cannot be empty',
      errormac: 'MAC is incorrect',
      noip: 'IP address cannot be empty',
      copySuccess: 'Copy successful',
      copyFailed: 'Failed successful',
      noPublickey: 'Public key cannot be empty',
      errorFile: 'File format is incorrect',
      startrecord: 'Start recording',
      reorderror: 'Start recording error, error code:{code}',
      stoprecord: 'Recording has stopped, storage location:{path}',
      localSnap: 'Local snap successfully, storage location:{path}',
      localSnapfail: 'Local snap failed,error code:{result}',
      platsnapsucc: 'Platform snap successfully',
      platsnapfail: 'Platform snap failed!(error code:{result})',
      yunterr: 'PTZ operation failed, error code:{result}',
      selectdev: 'Please select a camera',
      inputname: 'Please enter a name',
      inputrightname: 'Please enter the correct name',
      addpresucc: 'Add presets successfully',
      addprefail: 'Add presets failed!error code:{result}',
      updatepresucc: 'Modify the preset successfully',
      updateprefail: 'Modify the preset failed',
      delpresucc: 'Delete the preset successfully',
      delprefail: 'Delete the preset failed',
      playbackfail: 'Video playback failed,error code:{result}',
      downloadsucc: 'The video download task started successfully,storage location{downloadPath}',
      downloadfail: 'he video download task started failed',
      loginfail: 'The video management platform failed to log in. Please contact the administrator！',
      offline: 'Not online!',
      playfail: 'Playback failed',
      playsucc: 'Play the sound successfully',
      stopvoice: 'Stop play the sound',
      raisevoice: 'Adjust the volume',
      loadingfail: 'Failed to load',
      uploadSuccess: 'Uploaded successfully',
    },
  },
  /*
   * 国际化文本资源配置文件，配置规范如下：
   * 1、所有配置的key使用全小写配置，无论有几个单词，均使用全小写，建议每个key不超过两个单词
   * 2、每个模块使用一个大的对象，如system，表示系统公共文本资源配置，如login表示登录页面的国际化配置
   * 3、每个页面必须配置在对应模块下，如事件规则（eventrule）页面的国际化必须配置在事件中心模块（eventcontral）下
   * 4、每个页面必须按功能分类国际化资源配置，如页面分类如下：lable（普通文本）、placeholder（输入框的提示文本）、button（按钮文本）、message（提示消息文本）
   * 5、每个国际化资源配置建议不要超过4层，即最深的访问层级为：system.common.button.confirm
   */
  // 公共国际化资源配置
  system: {
    // 公共文本
    common: {
      // 公共按钮文本
      button: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        query: 'Query',
        clear: 'Clear',
        next: 'Next',
        previous: 'Previous',
        save: 'Save',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        play: 'Play',
      },
      // 公共消息
      message: {
        greet: 'Hello,',
        homepage: 'Homepage',
        nocenter: 'No central',
        systemerror: 'System error, please wait',
        reqfullscreen: 'Entry full screen',
        exitfullscreen: 'Exit full screen',
      },
    },
    platform: {
      // name: 'Comprehensive security management platform',
      name: 'Optima Integration Group',
      version: '',
    },
    theme: {
      default: 'Default',
      dark: 'Dark',
      light: 'Light',
    },
    menu: {
      0: 'Home page',
      11: 'Comprehensive situation',
      1101: 'Alarm center',
      110101: 'Historical warning',
      110102: 'Manual alarm',
      12: 'Comprehensive security',
      1102: 'Linkage management',
      110201: 'Linkage rules',
      1201: 'Video surveillance',
      120101: 'Video surveillance',
      120102: 'Video program',
      120103: 'Video strategy',
      1202: 'Alarm center',
      120201: 'Realtime alarm',
      120202: 'Alarm log',
      120203: 'Task management',
      1203: 'Video patrol',
      120301: 'Patrol plan',
      120302: 'Patrol task',
      120303: 'Patrol history',
      1204: 'Electronic patrol',
      120401: 'Patrol plan',
      120402: 'Patrol history',
      1205: 'Personnel control',
      120501: 'Personnel list',
      120502: 'Personnel management',
      1206: 'Vehicle control',
      120601: 'Vehicle list',
      120602: 'Vehicle management',
      13: 'Plan linkage',
      1301: 'Linkage management',
      130101: 'Linkage details',
      14: 'People management',
      1401: 'Control details',
      140101: 'Details added',
      140102: 'Details revised',
      1402: 'Black list',
      140201: 'Face alignment',
      140202: 'Face retrieval',
      15: 'Car management',
      1501: 'Car search',
      150101: 'Search details',
      1502: 'Traffic record',
      150201: 'Traffic list',
      16: 'Device management',
      1601: 'Device access',
      160101: 'Device list',
      1602: 'Device status',
      160201: 'Camera list',
      17: 'Environment monitor',
      1701: 'Log management',
      170101: 'Version management',
      18: 'System management',
      1801: 'Area management',
      180101: 'Area homepage',
      1802: 'Group management',
      180201: 'Account management',
    },
    video: {
      ability: 'Ability select',
      planConfig: {
        Mon: 'Mon',
        Tues: 'Tues',
        Wed: 'Wed',
        Thur: 'Thur',
        Fri: 'Fri',
        Sat: 'Sat',
        Sun: 'Sun',
      },
      // 收藏夹
      bookmark: {
        add: 'Add bookmark',
        edit: 'Edit bookmark',
        play: 'Play live video',
        bookmarkName: 'MarkName',
        ordinary: 'ordinary',
        car: 'car-discern',
        person: 'face-discern',
        tips: 'Please enter a folder name',
      },
    },
  },
  // 登录页面国际化资源配置
  login: {
    label: {},
    placeholder: {
      username: 'Enter a username',
      password: 'Enter password',
    },
    button: {
      submit: 'Login',
    },
    message: {},
  },
  home: {
    label: {
      apptitle: 'Personal shortcut panel',
      profile: 'Profile',
      theme: 'Switch theme',
      language: 'Switch language',
      homepage: 'Home page',
    },
    placeholder: {},
    button: {
      logout: 'Logout',
    },
    message: {
      removeapp: 'Remove from shortcut panel',
      addapp: 'Add to shortcut panel',
    },
  },
  // 公共业务组件国际化资源配置
  /**
   * 涵盖范围： bussines-modules\components\
   */
  business: {
    button: {
      capture: 'Capture',
      clip: 'Clip',
      clearClip: 'Clear',
      zoom: 'Zoom',
      fastCm: 'Fast control',
    },
    label: {
      videoName: 'Video name',
      operation: 'Operation',
    },
    placeholder: {
      keyword: 'Please enter a keyword to search',
    },
    message: {
      queryFailed: 'Query failed',
      offline: 'The Device is offline!',
      loadData: 'Loading data ...',
      nodata: 'No data',
    },
    title: {
      areaDevice: 'Regional device information',
      uploadVideo: 'Upload video',
    },
  },
  ...assemble.en,
}
